import { useState, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@components";
import { useWorkspace } from "../../context/WorkspaceContext";
import { WorkspaceRole } from "../../types";
import { ReadyToInvoice } from "../InvoiceList/ReadyToInvoice";

export const CustomerConsolidatedInvoice = ({
  customerId,
  renderTrigger,
}: {
  customerId: string;
  renderTrigger: (
    action: { onClick: () => void; disabled: boolean } | undefined,
  ) => ReactNode;
}) => {
  const [open, setOpen] = useState(false);
  const { activeWorkspace } = useWorkspace();
  const { t } = useTranslation("invoice");
  const allowed =
    activeWorkspace?.role === WorkspaceRole.Owner ||
    activeWorkspace?.role === WorkspaceRole.Administrator;
  return (
    <>
      {renderTrigger(
        allowed ? { onClick: () => setOpen(true), disabled: false } : undefined,
      )}
      <Dialog
        show={open}
        title={t("consolidated.title")}
        size="4xl"
        hideButtons
        toggleModal={() => setOpen(false)}
        content={
          open ? (
            <ReadyToInvoice
              key={`${activeWorkspace?.workspaceId}:${customerId}`}
              customerId={customerId}
            />
          ) : null
        }
      />
    </>
  );
};
